<template>
  <div>
    <q-dialog
      :visible="isShowLook"
      :title="titleMap[queryType]"
      width="60%"
      :innerScroll="false"
      :showFooter="false"
      @close="onCancel"
    >   
      <div class="head-box" v-if="queryType == 'drawLotsDrawLots'">
        <el-button type="primary" @click="importTable">导入</el-button>
        <el-button type="primary" @click="diaLogExportList('getExchangedPrizeList')">导出</el-button>
      </div>
      <my-table :isHeight="false" :tableData="tableData" :propList="propList" :loading="loading">
        <template #handle="scope">
          <el-button
            type="text"
            size="small"
            @click="checkGoods(scope.row)"
          >
            查看商品
          </el-button>
        </template>
      </my-table>
      <div style="text-align: right" v-if="queryType != 'couponDetail'">
        <el-pagination
          @size-change="dialogonSizeChange"
          @current-change="dialogonNumChange"
          :current-page="dialogpageNum"
          :page-size="dialogSize"
          :total="dialogTotal"
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </q-dialog>
    <import-dialog
      reportName="importExpressNo" 
      v-if="isShowImport" 
      :visible.sync="isShowImport"
    />
  </div>
</template>

<script>
import myTable from '@/components/my-table';
import pagePathMixin from '@/utils/page-path-mixin'
import {
  awardsArrPropList,
  goodsPropList,
  sessionsPropList,
  groupPropGoodsLis,
  groupPropNumberList,
  drawLotsSign,
  drawLotsDetail,
  drawLotsDrawLots,
  countMoneyDetailData,
  couponDetail,
} from '../config'
export default {
  mixins: [pagePathMixin],
  components: { myTable },
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      isShowLook: false,
      loading: false,
      queryType: '',
      titleMap: {
        goods: '商品详情(秒杀)',
        sessions: '场次详情',
        luckdraw: '奖品详情',
        groupGoodsNumber: '商品详情(拼团)',
        groupNumber: '开团数',
        drawLotsSign: '签文数据',
        drawLotsDetail: '奖品详情',
        drawLotsDrawLots: '已兑奖品',
        countMoneyDetail: '奖品详情',
        couponDetail: '优惠券详情'
      },
      propList: [],
      tableData: [],
      dialogrow: {},
      dialogSize: 1,
      dialogpageNum: 1,
      dialogTotal: 0,
      isShowImport: false,
    }
  },
  methods: {
    init(item,type) {
      if (type == 'question') {
        this.openSubPage({
          path: '/content/newaddOrEdit',
          query: { id: item.templateId, from: 'see', }
        })
        return
      }
      this.queryType = type
      if (type == 'luckdraw') {
        this.propList = awardsArrPropList
      } else if (type == 'goods') {
        this.propList = goodsPropList
      } else if (type == 'sessions') {
        this.propList = sessionsPropList
      } else if (type == 'groupGoodsNumber') {
        this.propList = groupPropGoodsLis
      } else if (type == 'groupNumber') {
        this.propList = groupPropNumberList
      } else if (type == 'drawLotsSign') {
        this.propList = drawLotsSign
      } else if (type == 'drawLotsDrawLots') {
        this.propList = drawLotsDrawLots
      } else if (type == 'drawLotsDetail') {
        this.propList = drawLotsDetail
      } else if (type == 'countMoneyDetail') {
        this.propList = countMoneyDetailData
      } else if (type == 'couponDetail') {
        this.propList = couponDetail
      }
      this.dialogrow = item;
      this.loading = true
      this.isShowLook = true;
    
      this.getactivityAwards(type);
    },
    getactivityAwards(type) {
      const params = {
        pageNum: this.dialogpageNum,
        pageSize: this.dialogSize,
        filterData: {
          activityId: this.dialogrow.activityId || this.detail.activityId,
          moduleId: this.dialogrow.moduleId || 0,
          sessions: this.dialogrow.sessions || '',
          sessionId: this.dialogrow.sessionId || ''

        },
      };
      let requestMap = {
        luckdraw: 'activityAwards',
        goods: 'getActivityGoods',
        sessions: 'getActivitySessions',
        groupGoodsNumber: 'getGroupBuyingGoodsList',
        groupNumber: 'getGroupBuyingTeamList',
        drawLotsSign: 'getDrawLotsList',
        drawLotsDrawLots: 'getExchangedPrizeList',
        drawLotsDetail: 'getPrizeList',
        countMoneyDetail: 'getCountMoneyActivityAwards',
        couponDetail: 'getCouponDetail'
      }
      
      this.$api.ActivityManagement[requestMap[type]](params).then((res) => {
        if (res.success) {
          if (type == 'couponDetail') {
            this.tableData = res.data;
          } else {
            this.tableData = res.data.list;
            this.dialogTotal = res.data.total;
          }
          
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    dialogonSizeChange(pageSize) {
      this.dialogSize = pageSize;
      // 切换每页条数后从第一页查询
      this.dialogpageNum = 1;
      this.getactivityAwards(this.queryType);
    },
    dialogonNumChange(pageNum) {
      this.dialogpageNum = pageNum;
      this.getactivityAwards(this.queryType);
    },
    checkGoods(obj) {
      this.isShowLook = false;
      this.init(obj,'goods')
    },
    importTable() {
      this.isShowImport = true
    },
    diaLogExportList(type) {
      let params = {
        activityId: this.$route.query.activityId,
        isDecrypt: true
      };
      this.$api.common.doExport(type, params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    onCancel() {
      this.isShowLook = false;
      this.dialogpageNum = 1
      this.dialogSize = 20
    },
  }
}
</script>

<style scoped lang="stylus">
 .head-box {
    float: right;
    margin-bottom: 10px;
  }
</style>